import { inject, Injectable, Injector } from '@angular/core';

import { createProviderToken } from '@core/common-legacy';

import { IconsContainerStrategy } from './contracts';
import { IconsContainerService } from './icons-container.service';
import type { IconName } from '../common/icon/icons.type';

const { provide: provideIconsUrlResolver, inject: injectIconsUrlResolver } =
  createProviderToken<(name: IconName) => string>('Icons url resolver')();

@Injectable({ providedIn: 'root' })
export class IconsContainerLazyStrategy implements IconsContainerStrategy {
  private readonly iconsContainerService = inject(IconsContainerService);
  private readonly iconsUrlResolver = injectIconsUrlResolver();

  private iconsRegistry = new Map<IconName, Promise<string>>();

  public async load(name: IconName, element: HTMLElement, injector: Injector): Promise<void> {
    if (!name) return console.warn('IconsContainerLazyStrategy: No icon name provided');

    const { instance } = await this.iconsContainerService.getContainer(element, injector);
    if (instance.hasVisibleIcon(name)) return;

    if (!this.iconsRegistry.has(name)) {
      this.iconsRegistry.set(
        name,
        fetch(this.iconsUrlResolver(name)).then(res => res.text()),
      );
    }
    const symbol = await this.iconsRegistry.get(name)!;
    if (instance.hasVisibleIcon(name)) return;

    instance.updateVisibleIcons(name, symbol);
  }
}

export { provideIconsUrlResolver };
